import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { isAdmin } from '../lib/api'

interface RequireAdminProps {
  children: React.ReactNode
}

export default function RequireAdmin({ children }: RequireAdminProps) {
  const [status, setStatus] = useState<'loading' | 'admin' | 'not-admin' | 'unauthenticated'>('loading')

  useEffect(() => {
    supabase.auth.getUser().then(async ({ data }) => {
      if (!data.user) {
        setStatus('unauthenticated')
        return
      }
      const admin = await isAdmin()
      setStatus(admin ? 'admin' : 'not-admin')
    })
  }, [])

  if (status === 'loading') {
    return <div className="min-h-screen bg-gray-950" />
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />
  }

  if (status === 'not-admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
